define([
	"dojo/_base/declare",
	"csi/action/ManageController",
	"csi/xml"
], function(declare, ManageController, xml) {

	return declare(ManageController, {
		bShowProgress: true,

		/**
		 * @override
		 * Add dependency path to get new Crew of CrewHolder when adding crew
		 */
		getReturnNodeRequest(urlsNew) {
			const request = this.inherited(arguments);
			if (request && !this.m_bToggle) {
				request.addDependencyPaths(["Child:Crew"]);
			}

			return request;
		},

		/**
		 * @override
		 * Write special request to create/delete crew
		 */
		toWriter() {
			this.m_writer.callMethod("SiteAdmin", "HoldsCrew")
				.addParameter(xml.PROP_URL, xml.ATTR_REF, this.m_urlParent)
				.addParameter("HoldsCrew", xml.ATTR_BOOLEAN, !this.m_bToggle);
		}
	});
});